﻿import { NgModule} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { UserTableComponent } from "./table/user-table.component";
import { ResetPasswordModalComponent } from "./reset-password-modal/reset-password-modal.component";
import { BsDropdownModule, CollapseModule, ModalModule } from "ngx-bootstrap";
import { InterceptorService } from "../../../service/components/authentication/interceptor.service";
import { UserManageService } from "../../../service/api/jubili/user-manage.service";
// ------------------------------------------End Service----------------------------------------------------------------------//

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        SharedModule,
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        ModalModule.forRoot()
    ],
    declarations: [
        UserTableComponent,
        ResetPasswordModalComponent
    ],
    exports: [
        UserTableComponent,
        ResetPasswordModalComponent,
        SharedModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        UserManageService
    ]
})

export class UserManageModule { }
